import { clearError, selectUiLoader } from "features/ui/slice";
import useSnackbar from 'hooks/useSnackbar';
import { cloneElement, isValidElement, PropsWithChildren, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store";
import LoadingMessageBox from "./LoadingMessageBox";

interface LoadingWrapperProperties {
    actionName: string,
    mode?: 'disable' | 'hide'
}



function LoadingWrapper({ actionName, children, mode = 'hide' }: PropsWithChildren<LoadingWrapperProperties>) {

    const { loading, error } = useSelector(selectUiLoader(actionName));
    const { displayError } = useSnackbar();

    const dispatch = useAppDispatch();

    const DisabledChildren = () => {

        if (isValidElement(children)) {
            return cloneElement(children, { disabled: true });
        }
        return null;


    }

    const clearUiError = useCallback(
        () => {
            dispatch(clearError(actionName));
        },
        [dispatch, actionName],
    )


    useEffect(() => {
        if (error) {
            displayError(error);
            clearUiError();
        }

    }, [error, displayError, clearUiError])

    return (
        <>
            {loading && <LoadingMessageBox />}
            {loading && mode === 'disable' && <DisabledChildren />}
            {!loading && children}
        </>
    );
}

export default LoadingWrapper;